import { render } from "./OffersImport.vue?vue&type=template&id=dacb5b3e"
import script from "./OffersImport.vue?vue&type=script&lang=js"
export * from "./OffersImport.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QFile,QTable,QTr,QTd,QSelect});
